import { render, staticRenderFns } from "./layout-own-carousel.vue?vue&type=template&id=4a25a0a8&scoped=true&"
import script from "./layout-own-carousel.vue?vue&type=script&lang=js&"
export * from "./layout-own-carousel.vue?vue&type=script&lang=js&"
import style0 from "./layout-own-carousel.vue?vue&type=style&index=0&id=4a25a0a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a25a0a8",
  null
  
)

export default component.exports